module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVHgBlVELDYAgEEUTGMEINtAm2sAIVqCBRsAERjACEZgJzmPCYCfft70xuPeO27uGVQAAJjxGZFMi7pAr8gIHnhIvROyj/42iuyEVxHFb8YDcEuLD0GK2Rh5vDofR7MEx9cV0lRmTSKWoQ+EBkxszs4aNmJRfbxPeh9wFKwF8u/STnlgpvMQlrbUZrx3vZLUwv/b0/QXnlzmUAPzlmAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sendFly.png
// module id = DQsv
// module chunks = 1